import { FormikProps } from "formik";
import { ExecuteModel } from "../../../../Steps/ExecuteModel";
import { IParticipantEmailDataModel } from "../../../models/ParticipantEmail";

export enum ParticipantSelectType {
    All = "All",
    AllParticipants = "AllParticipants",
    SelectedParticipants = "SelectedParticipants",
}

export interface IParticipantResponse {
    participantsByType: IParticipant[];
}

export interface IParticipant {
    participantID: string;
    name: string;
}

export interface IParticipantSelectorProps {
    FieldLabel: string;
    FieldGroup?: string;
    SelectionTypeOptions?: { [type in ParticipantSelectType]?: string };
    Participants: IParticipant[];

    FormikProps: FormikProps<ExecuteModel<IParticipantEmailDataModel>>;
    Required: boolean;
}

export * from "./ParticipantSelector";
